<template>
  <div class="macro-widget d-flex flex-column h-100">
    <div class="macro-widget__list flex-grow-1">
      <button
        v-for="item in macros"
        :key="item.id"
        type="button"
        class="btn btn-sm macro-widget__btn"
        :style="btnStyle(item)"
        :disabled="running"
        @click="run(item)"
      >
        <i
          class="fas"
          :class="runningId === item.id ? 'fa-spinner fa-spin' : 'fa-' + (item.icon || 'play')"
        />
        <span class="macro-widget__label">{{ item.name }}</span>
        <span class="macro-widget__count">{{ item.steps.length }} step{{ item.steps.length === 1 ? '' : 's' }}</span>
      </button>
      <p v-if="!macros.length" class="small text-muted mb-0">
        Belum ada macro.
        <router-link to="/macros">Buat di menu Macros</router-link>
        atau pilih di settings widget.
      </p>
    </div>

    <div v-if="status" class="small mt-2" :class="ok ? 'text-success' : 'text-danger'">{{ status }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { contrastText } from '@/widgets/macros'

export default {
  props: {
    config: { type: Object, default: () => ({}) },
    widgetId: { type: String, default: '' },
  },
  data() {
    return {
      running: false,
      runningId: null,
      status: '',
      ok: false,
    }
  },
  computed: {
    ...mapGetters('macro', { library: 'generalMacros' }),
    selectedIds() {
      return Array.isArray(this.config.macroIds) ? this.config.macroIds.map(Number) : []
    },
    macros() {
      if (!this.selectedIds.length) return this.library
      const set = new Set(this.selectedIds)
      return this.library.filter((m) => set.has(m.id))
    },
  },
  mounted() {
    this.fetchMacros().catch(() => {})
  },
  methods: {
    ...mapActions('macro', ['fetchMacros', 'runMacro']),
    btnStyle(item) {
      const bg = item.color || '#4798e8'
      return {
        backgroundColor: bg,
        borderColor: bg,
        color: contrastText(bg),
      }
    },
    async run(item) {
      if (this.running || !item?.steps?.length) return
      this.running = true
      this.runningId = item.id
      this.status = ''
      this.ok = false
      try {
        const res = await this.runMacro(item)
        this.ok = res.failed === 0
        this.status = res.failed
          ? `Finished with errors — ${res.done} ok, ${res.failed} failed`
          : `Done — ${res.done}/${res.total} steps`
      } catch (e) {
        this.ok = false
        this.status = e.message || 'Failed'
      } finally {
        this.running = false
        this.runningId = null
      }
    },
  },
}
</script>

<style scoped>
.macro-widget {
  color: var(--ws-text);
}
.macro-widget__list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  overflow: auto;
  min-height: 0;
}
.macro-widget__btn {
  display: flex;
  align-items: center;
  gap: 0.5em;
  text-align: left;
  white-space: normal;
  line-height: 1.3;
  font-size: 1em;
  font-weight: 600;
}
.macro-widget__label {
  flex: 1;
  min-width: 0;
}
.macro-widget__count {
  font-size: 0.75em;
  font-weight: 500;
  opacity: 0.85;
}
.macro-widget__btn:disabled {
  opacity: 0.65;
}
</style>
